import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'gatsby';
import BackArrow from '-!svg-react-loader!../assets/images/icons/back-arrow.svg'

const Breadcrumb = ({ location, catTitle, currentTitle, backPath, backText, collectionHierarchy, collectionFilter }) => {
  const [items, setItems] = useState([]);
  const breadcrumb = useRef(null);
  const wrapper = useRef(null);

  // Building breadcrumb items
  useEffect(() => {
    // Home item
    const breadcrumbItems = [
      { 'slug': '/', 'title': 'Home' },
    ];

    const pathArray = location.pathname.split('/').filter(element => element);

    const addCrumb = (collection, prevPath = '/collection', skipLast = false) => {
      if(!collection) return false;
      if(collection.handle === location.pathname.split('/').filter(p => p).pop()) return false;

      const newPath = prevPath + '/' + collection.handle;

      breadcrumbItems.push({
        'slug': newPath,
        'title': collection.title,
      })

      if(collection.subs) {
        addCrumb(collection.subs[0], newPath)
      }
    }

    // Collection  pages
    if (pathArray[0] === 'collection') {
      if(collectionHierarchy.length) {
        addCrumb(collectionHierarchy[0], null, true)
      } else {
        breadcrumbItems.push({
          'slug': '/shop',
          'title': `Shop by ${pathArray[0]}`,
        })
      }
    }

    if(backPath && backPath.includes('/shop') && !collectionFilter.length) {
      breadcrumbItems.push({
        'slug': '/shop',
        'title': 'Shop',
      })
    } else if(!backPath) {
      breadcrumbItems.push({
        'slug': '/shop',
        'title': 'Shop',
      })
    } else if(backPath && backPath.includes('/search')) {
      breadcrumbItems.push({
        'slug': backPath,
        'title': 'Search Results',
      })
    }

    // Handle collection filters
    if (collectionFilter && collectionFilter.length) {
      const collectionPath = '/collection';
      let currentPath = collectionPath;

      collectionFilter.forEach((collection) => {
        currentPath = `${currentPath}/${collection.handle}`;

        breadcrumbItems.push({
          'slug': currentPath,
          'title': collection.label,
        });
      });
    }

    // Current page
    if (location) {
      breadcrumbItems.push({
        'slug': location.pathname,
        'title': currentTitle || pathArray[pathArray.length - 1],
      })
    }

    setItems(breadcrumbItems);
  }, [catTitle, currentTitle, location, collectionHierarchy, collectionFilter, backPath])

  /**
   * Mobile scrolling, showing/hiding edge fades
   */
  useEffect(() => {
    const breadcrumbRef = breadcrumb.current;
    const wrapperRef = wrapper.current;

    if (!wrapperRef || !breadcrumbRef) { return false }

    let didScroll = false;

    const getScrollDistance = () => {
      didScroll = true;

      if (breadcrumbRef.scrollLeft > 1) {
        wrapperRef.classList.remove('start');
      } else {
        wrapperRef.classList.add('start');
      }

      if (breadcrumbRef.scrollLeft + breadcrumbRef.clientWidth >= breadcrumbRef.scrollWidth) {
        wrapperRef.classList.add('end');
      } else {
        wrapperRef.classList.remove('end');
      }
    }

    breadcrumbRef.addEventListener('scroll', getScrollDistance);

    setInterval(function () {
      if (didScroll) { didScroll = false; }
    }, 1000 / 10);

    return function cleanup() {
      breadcrumbRef.removeEventListener('scroll', getScrollDistance);
    };
  }, [])

  return (
    <div className="Breadcrumb">
      {backPath && backText && (
        <Link to={backPath} className="Breadcrumb__back">
          <BackArrow />{backText}
        </Link>
      )}
      <div className="Breadcrumb__wrapper" ref={wrapper}>
        <ul className="Breadcrumb__list" ref={breadcrumb}>
          {items.map((item, index) => (
            <li key={index} className="Breadcrumb__item">
              <Link to={item.slug} className="Breadcrumb__item__link">
                {item.title}
              </Link>
              {index !== (items.length - 1) && (
                <span className="Breadcrumb__item__separator"> > </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Breadcrumb;
